import Tab from "components/Tab";
import Beta from "../../../../contents/docs/workflows/_snippets/beta.mdx";
import * as React from 'react';
export default {
  Tab,
  Beta,
  React
};